import { useMutation } from "react-query";
import { queryClient } from "services/queries";
import { postRemoveAddress } from "../requests/Addresses";

export function useMutationRemoveAddress() {
    const query = useMutation(postRemoveAddress, {
        onSuccess: (data) => {
            if(data?.success) {
                // console.log(data)
                queryClient.invalidateQueries('apiQueryAddresses')
            } else {
                // console.log(data?.errors)
            }
        }, onError: (data) => {
            // console.error(data)
        }
    });
    return query;
}
